import axios from "axios";

const API_URL = "https://supadaa.com/api/";

// FormData mate Content-Type manually set nathi karvu (axios boundary jate nakhe che)
const authHeaders = () => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
});

// res = { status, data: [...], products: [...] }
const getAll = async () => {
  const res = await axios.get(`${API_URL}watch-buys`, { headers: authHeaders() });
  return res.data;
};

// formData: product_id, title, video(file), poster(file?), sort_order, show_on_home, show_on_product, status
const create = async (formData) => {
  const res = await axios.post(`${API_URL}watch-buys/create`, formData, {
    headers: authHeaders(),
  });
  return res.data;
};

// formData: id + upar na badha (video/poster optional), remove_poster?
const update = async (formData) => {
  const res = await axios.post(`${API_URL}watch-buys/update`, formData, {
    headers: authHeaders(),
  });
  return res.data;
};

const remove = async (id) => {
  const res = await axios.post(
    `${API_URL}watch-buys/delete`,
    { id },
    { headers: { ...authHeaders(), "Content-Type": "application/json" } }
  );
  return res.data;
};

export default { getAll, create, update, remove };